const EVENT_STYLES = {
  submission_pending: { icon: "⏳", accent: "bg-amber-500" },
  submission_approved: { icon: "✅", accent: "bg-sky-500" },
  submission_fully_approved: { icon: "🎉", accent: "bg-green-500" },
  submission_rejected: { icon: "❌", accent: "bg-red-500" },
  submission_unlocked: { icon: "🔓", accent: "bg-indigo-500" },
};

const DEFAULT_STYLE = { icon: "📄", accent: "bg-indigo-500" };

export const getNotificationStyle = (notification) =>
  EVENT_STYLES[notification?.event] || DEFAULT_STYLE;

// แจ้งเตือนใบเสนอราคาแบบเก่าอาจไม่มี title ให้ใช้ message เป็นหัวข้อแทน
export const getNotificationText = (notification) => {
  const title = String(notification?.title || "").trim();
  const message = String(notification?.message || "").trim();
  if (!title) return { title: message, message: "" };
  return { title, message };
};

const RELATIVE_UNITS = [
  { label: "ปี", ms: 365 * 24 * 60 * 60 * 1000 },
  { label: "เดือน", ms: 30 * 24 * 60 * 60 * 1000 },
  { label: "สัปดาห์", ms: 7 * 24 * 60 * 60 * 1000 },
  { label: "วัน", ms: 24 * 60 * 60 * 1000 },
  { label: "ชั่วโมง", ms: 60 * 60 * 1000 },
  { label: "นาที", ms: 60 * 1000 },
];

export const formatRelativeTime = (value, now = new Date()) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const diff = now.getTime() - date.getTime();
  if (diff < 60 * 1000) return "เมื่อสักครู่";
  const unit = RELATIVE_UNITS.find((u) => diff >= u.ms);
  return `${Math.floor(diff / unit.ms)} ${unit.label}ที่แล้ว`;
};

// link จาก backend ต้องเป็น path ภายในแอปเท่านั้น (กัน "//host" หรือ URL ภายนอก)
export const getInternalNotificationLink = (notification) => {
  const link = String(notification?.link || "").trim();
  if (!link.startsWith("/") || link.startsWith("//") || link.startsWith("/\\")) {
    return null;
  }
  return link;
};

export const formatBadgeCount = (count) => (count > 99 ? "99+" : String(count));

// รวมหน้าถัดไปเข้ากับรายการเดิม โดยไม่ให้ _id ซ้ำ (กรณีมีแจ้งเตือนใหม่แทรกระหว่างเลื่อนหน้า)
export const appendNotifications = (current, next) => {
  const seen = new Set(current.map((n) => n._id));
  return [...current, ...next.filter((n) => !seen.has(n._id))];
};
